import { z } from 'zod';
export const dateParser = () => {
    return z.coerce.date();
};
